import React from 'react'
import { withRouter } from 'react-router'

import { urlTo } from 'helpers/router'

import Button from 'components/_old/Button/Button.jsx'
import Link from 'components/_old/Link/Link.jsx'

import { regulatoryTypes } from 'constants/portfolio'

const StartANewTransferLink = withRouter(({ location }) => {
  const prev = location?.pathname + location?.search

  return (
    <Button mods={{ size: 'biggest block', text: 'big' }}>
      <Link
        to={urlTo('dashboard.transfer-sipp', null, {
          noRedirect: true,
          prev,
        })}
        analyticsEvent={{
          action: 'transfer_click',
          transfer_type: regulatoryTypes.SIPP,
          referrer: window.location.pathname,
        }}
      >
        Start a new pension transfer
      </Link>
    </Button>
  )
})

export { StartANewTransferLink }
